module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markCorrect--dark-f997ccfdf79e89de948b71f45a85c5be.png";